export const WANTS_ANY_VALUE = "__any__";
export const WANTS_ANY_EDITION_VALUE = "__any_edition__";

export const WANTS_LANGUAGE_OPTIONS = [
  { value: "en", label: "English" },
  { value: "de", label: "German" },
  { value: "fr", label: "French" },
  { value: "es", label: "Spanish" },
  { value: "it", label: "Italian" },
  { value: "jp", label: "Japanese" },
  { value: "cn", label: "Chinese" },
  { value: "kr", label: "Korean" },
  { value: "ru", label: "Russian" },
  { value: "pt", label: "Portuguese" }
];

export const WANTS_CONDITION_OPTIONS = [
  { value: "M", label: "Mint" },
  { value: "NM", label: "Near Mint" },
  { value: "EX", label: "Excellent" },
  { value: "GD", label: "Good" },
  { value: "LP", label: "Light Played" },
  { value: "PL", label: "Played" },
  { value: "PO", label: "Poor" }
];

export const WANTS_BOOLEAN_OPTIONS = [
  { value: WANTS_ANY_VALUE, label: "Any" },
  { value: "false", label: "No" },
  { value: "true", label: "Yes" }
];

export const LANGUAGE_TO_COUNTRY = {
  en: "gb",
  gb: "gb",
  de: "de",
  ger: "de",
  fr: "fr",
  fra: "fr",
  es: "es",
  spa: "es",
  it: "it",
  ita: "it",
  jp: "jp",
  jpn: "jp",
  cn: "cn",
  chi: "cn",
  zho: "cn",
  kr: "kr",
  kor: "kr",
  ru: "ru",
  rus: "ru",
  pt: "pt",
  por: "pt"
};

export const CONDITION_COLORS = {
  M: "#1fc9a4",
  NM: "#4caf50",
  EX: "#6da13d",
  GD: "#eeff00",
  LP: "#ee9a1d",
  PL: "#d65f30",
  PO: "#fa3c2e"
};

export function getWantsLanguageLabel(value) {
  if (value === WANTS_ANY_VALUE) {
    return "Any";
  }

  return WANTS_LANGUAGE_OPTIONS.find((option) => option.value === value)?.label || String(value || "en").toUpperCase();
}

export function getWantsConditionLabel(value) {
  if (value === WANTS_ANY_VALUE) {
    return "Any";
  }

  return WANTS_CONDITION_OPTIONS.find((option) => option.value === value)?.label || String(value || "NM").toUpperCase();
}

export function getWantsBooleanLabel(value) {
  return WANTS_BOOLEAN_OPTIONS.find((option) => option.value === value)?.label || "Any";
}

export function getLanguageCountryCode(value) {
  if (!value || value === WANTS_ANY_VALUE) {
    return "xx";
  }

  return LANGUAGE_TO_COUNTRY[String(value).trim().toLowerCase()] || "xx";
}

export function getConditionColor(value) {
  if (!value || value === WANTS_ANY_VALUE) {
    return "#e2e8f0";
  }

  return CONDITION_COLORS[String(value).trim().toUpperCase()] || "#777";
}